import { useEffect, useState } from "react";
import Model from "@tripian/model";
import { api } from "@tripian/core";

const useTourCategories = (cityId?: string, providerId?: string) => {
  const [categories, setCategories] = useState<Model.TourCategory[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api
      .tourCategories(cityId, providerId)
      .then((data) => setCategories(data))
      .catch(() => setCategories([]))
      .finally(() => setLoading(false));
  }, [cityId, providerId]);

  return { categories, loading };
};

export default useTourCategories;